import { supabase } from "./supabase";

const BUCKET = "empresa-logos";
const ASSETS_BUCKET = "assets";
const LAUDO_FOTOS_BUCKET = "laudo-fotos";

export function getLogoUrl(empresaId: string): string {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  return `${supabaseUrl}/storage/v1/object/public/${BUCKET}/${empresaId}_logo.png`;
}

export function getNoPhotoUrl(): string {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  return `${supabaseUrl}/storage/v1/object/public/${ASSETS_BUCKET}/sem_foto/sem_foto.png`;
}

export function getRTSignatureUrl(rtId: string): string {
  const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
  return `${supabaseUrl}/storage/v1/object/public/${LAUDO_FOTOS_BUCKET}/rt_assinaturas/${rtId}.png`;
}

export async function uploadRTSignature(
  rtId: string,
  file: File,
): Promise<string> {
  const filePath = `rt_assinaturas/${rtId}.png`;

  const { error } = await supabase.storage
    .from(LAUDO_FOTOS_BUCKET)
    .upload(filePath, file, {
      cacheControl: "3600",
      upsert: true,
      contentType: "image/png",
    });

  if (error) {
    throw new Error(`Erro ao enviar assinatura: ${error.message}`);
  }

  const { data } = supabase.storage
    .from(LAUDO_FOTOS_BUCKET)
    .getPublicUrl(filePath);
  return data.publicUrl;
}

export async function uploadLogo(
  empresaId: string,
  file: File,
): Promise<string> {
  const filePath = `${empresaId}_logo.png`;

  const { error } = await supabase.storage.from(BUCKET).upload(filePath, file, {
    cacheControl: "3600",
    upsert: true,
    contentType: file.type,
  });

  if (error) {
    throw new Error(`Erro ao enviar logo: ${error.message}`);
  }

  const { data } = supabase.storage.from(BUCKET).getPublicUrl(filePath);
  return data.publicUrl;
}
